<template>
  <div>
    <el-progress v-if="socket_key" :percentage="progress"></el-progress>
    <div class="search-wrap">
      <el-button size="mini" @click="pageChange(1)">查询</el-button>


<!--      <el-button size="mini" @click="getAllExcel()">综合账单导出</el-button>-->
    </div>
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <el-descriptions-item label="项目房产">
          {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        </el-descriptions-item>
        <el-descriptions-item label="抄表月份">
          <el-date-picker
            v-model="mainObj.read_month"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="pageChange(1)"
            placeholder="选择月">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="客户房产">
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            size="mini"
            v-model="mainObj.house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            placeholder="请输入房产"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="应收日期">
          <el-date-picker
            v-model="where.should_charge_date"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="pageChange(1)"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="descriptions-label-class" label="客户名称">
          <el-autocomplete
            class="w-300"
            size="mini"
            v-model="where.customer_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入姓名"
            @select="handleSelect2"
          ></el-autocomplete>
        </el-descriptions-item>

        <el-descriptions-item label="收费项目">
          <el-select size="mini" style="width: 100%" v-model="where2.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select size="mini" style="width: 100%" v-model="where2.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>

        <el-descriptions-item label="能耗类型">
          <el-select size="mini" style="width: 100%" v-model="where.energy" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in energy_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="是否锁定">
          <el-select size="mini" style="width: 100%" v-model="where.is_lock" clearable filterable placeholder="请选择" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in [{name:'未锁定',val:0},{name:'已锁定',val:1}]" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="是否审核">
          <el-select size="mini" style="width: 100%" v-model="where.is_examine" clearable filterable placeholder="请选择" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in [{name:'未审核',val:0},{name:'待审核',val:1},{name:'已审核',val:2},{name:'已驳回',val:-1}]" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div>
      <div class="header-tip">
        用量计费： {{formatMoney(count_obj.allocated_amount_sum,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        分摊计费： {{formatMoney(count_obj.charge_sum,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        误差金额 [绝对值]： {{formatMoney(count_obj.unusual_change_amount_abs,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        计费条数： {{count_obj.user_count||0}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        仪表个数： {{count_obj.count||0}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>

    <div class="table-wrap">
      <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" @selection-change="handleSelectionChange">
<!--        <el-table-column type="selection" width="55" align="center"></el-table-column>-->
<!--        <el-table-column label="序号" prop="id" width="100" align="center"></el-table-column>-->
        <el-table-column label="仪表编号" prop="number" width="150" fixed="left" align="center"></el-table-column>
        <el-table-column label="仪表名称" prop="name" width="200" align="center"></el-table-column>
        <el-table-column label="仪表等级" prop="meter_level" width="90" align="center"></el-table-column>
        <el-table-column label="用量计费（元）" prop="allocated_amount_sum" width="150" align="center"></el-table-column>
        <el-table-column label="分摊计费（元）" prop="charge_sum" width="150" align="center"></el-table-column>
        <el-table-column label="异动差（元）" prop="unusual_change_amount" width="150" align="center">
          <template slot-scope="scope">
            {{scope.row.unusual_change_amount?scope.row.unusual_change_amount:0}}
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(scope.row.unusual_change_amount,1)===1"></i>
            <i class="el-icon-bottom" style="color: #fd0000" v-if="unusualChange(scope.row.unusual_change_amount,1)===-1"></i>
          </template>
        </el-table-column>
        <el-table-column label="分摊户数" prop="user_count" width="100" align="center"></el-table-column>
        <el-table-column label="分摊占比总和" prop="moo_proportion" width="100" align="center"></el-table-column>
        <el-table-column label="扩展占比总和" prop="moo_proportion_ext" width="100" align="center"></el-table-column>
        <el-table-column label="线损占比总和" prop="moo_proportion_loss" width="100" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination
        :current-page="pageData.page"
        :page-size="pageData.pageSize"
        :total="pageData.total"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>

  </div>
</template>

<script>
import {Loading} from "element-ui";
import MeterHttp from "../../../common/MeterHttp";
import moment from "moment";

export default {
  name: "MeterOrderUnusualChange1",
  components: {},
  provide() {
    return {
      where: this.where,
    }
  },
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      activeName: 1,
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        house_id:"",
        house_name:"",
        customer_id:"",
        customer_name:"",
        should_charge_date:"",
        energy:"",
        is_lock:"",
        is_examine:"",
      },
      where2:{
        charging_standard:'',
        chargeItem_name_id:''
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      house_charge_list:[],
      house_charge_item_list:[],
      chargeItem_name_ids:null,
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 50,
        page: 1
      },
      count_obj:{},
      multipleSelection: [],
      progress: 0,
      socket_key:null,
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.mainObj.project_id&&this.getHouseChargeitemNameList();
    this.mainObj.project_id&&this.getHouseChargeList();
    this.where.should_charge_date=moment(this.mainObj.read_month).endOf('month').format("YYYY-MM-DD");
    this.pageChange(1)
  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderObject/getUnusualChangeList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
          that.count_obj=res.data.count_obj||{}
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      // this.where.house_id=item.id||0;
      this.where.house_name=item.value;
      this.pageChange(1);
    },
    querySearchAsync(queryString, cb) {
      const that = this;
      if(!queryString){
        cb([])
        return false
      }
      let from_data={}
      from_data.key_name=queryString;
      ERP.getRequest({url:"admin/Customer/getCustomerList",data:from_data},res=>{
        if (res.code) {
          cb(res.data.map(ret=>{return {
            value:`${ret.name}-【${(ret.house_list.map(re=>re.address).join(','))}】`,//
            id:ret.id,
            data:ret
          }}));
        }
      })
    },
    handleSelect2(item) {
      const that = this;
      // that.where.customer_id=item.data.id||0;
      that.where.customer_name=item.data.name;
      that.pageChange(1);
    },
    getAllExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;

      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderHouse/getMeterOrderHouseExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
      }, res => {
        if (res.code) {
          window.open(res.data)
          // that.initTaskClient(res.data,()=>{
          //
          // })
        }
        that.loading = false;
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where2.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where2.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    reNumber(x){
      return Math.floor(x*100)/100
    },
    unusualChange(val,rate=10){
      if(Math.abs(val)<=rate){
        return 0
      }
      if(val>0){
        return 1
      }else {
        return -1
      }
    }
  },
  computed:{
    all_money(){
      let m_arr=this.pageData.list.map(ret=>ret.charge_sum*1)
      return m_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },
    user_order_ids(){
      return this.multipleSelection.map(ret=>ret.id)
    }
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    },
    "mainObj.project_id":function (n,o) {
      if(n){
        this.getHouseChargeitemNameList();
      }
    },
    "mainObj.read_month":function (n,o) {
      if(n){
        //设置抄表月的最后一天为应收日期
        this.where.should_charge_date=moment(n).endOf('month').format('YYYY-MM-DD');
      }else {
        this.where.should_charge_date = '';
      }
    },
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.where2.charging_standard="";
        this.getHouseChargeList();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common.scss";
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
.meter-order-table-wrap{
  margin-top: 20px;
}
.meter-order-table{
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 10px;
}
.meter-order-table th{
  background-color: #f5f7fa;
  font-weight: 500;
  padding: 10px;
  border: 1px solid #dcdfe6;
  text-align: center;
}
.meter-order-table td{
  padding: 10px;
  border: 1px solid #dcdfe6;
  text-align: center;
}
//.meter-order-table td:first-child{
//  text-align: left;
//}
//.meter-order-table td:last-child{
//  text-align: right;
//}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderUnusualChange1.vue